// jshint esversion: 8

export default {
  all: state => state.data,
  stopsByTripMap: state => state.stopsByTripMap
};
